{
  "Paramètres": "Settings",
  "Patients": "Patients",
  "Clinique": "Clinic",
  "Questionnaire": "Questionnaire",
  "Laboratoire": "Laboratory",
  "Laboratoires": "Laboratories",
  "Implant": "Implant",
  "Implants": "Implants",
  "Déconnexion": "Logout",
  "Connexion": "Login",
  "Biométrie": "Biometrics",
  "Physiologie": "Physiology",
  "Habitude": "Habits",
  "Rapport": "Report",
  "Mercide de remplir le": "Please fill out the",
  "formulaire d'habitudes": "habits form",
  "Intervalle": "Interval",
  "AV(LogMAR)": "VA (LogMAR)",
  "Occurence": "Occurrence",
  "Infini": "Infinite",
  "Sélectionner une valeur": "Select a value",
  "Lunettes": "Glasses",
  "Annuler": "Cancel",
  "Enregistrer": "Save",
  "Fermer": "Close",
  "Oui": "Yes",
  "Non": "No",
  "Activité": "Activity",
  "Optionnel": "Optional",
  "Pourquoi le patient souhaite garder cette profondeur de champ ?": "Why does the patient want to keep this depth of field?",
  "Distance minimum (m)": "Minimum distance (m)",
  "Distance maximum (m)": "Maximum distance (m)",
  "Préconisé à": "Recommended for",
  "Informations générales": "General information",
  "Sexe": "Gender",
  "Valider": "Validate",
  "Informations générales enregistrées": "General information saved",
  "Habitudes enregistrées": "Habits saved",
  "Temps d'éveil": "Awake time",
  "Vision de près": "Near vision",
  "Vision intermédiaire": "Intermediate vision",
  "Vision de loin": "Distance vision",
  "VL": "DV",
  "VI": "IV",
  "VP": "NV",
  "Activités préférentielles": "Preferential activities",
  "Précédent": "Previous",
  "Suivant": "Next",
  "Source": "Source",
  "Courbes de défocus": "Defocus curves",
  "Courbe de défocus": "Defocus curve",
  "Monocular": "Monocular",
  "Binocular": "Binocular",
  "obtenue avec": "obtained with",
  "patients": "patients",
  "avec la méthodologie": "with the methodology",
  "Comparaison d'implant": "Implant comparison",
  "Implants favoris": "Favorite implants",
  "Choisir": "Choose",
  "Retirer des favoris": "Remove from favorites",
  "Ajouter aux favoris": "Add to favorites",
  "Larmes": "Tears",
  "Cornée": "Cornea",
  "Pupille": "Pupil",
  "Rétine et/ou nerf optique": "Retina and/or optic nerve",
  "Longueur axiale": "Axial length",
  "Correction": "Correction",
  "Matériau": "Material",
  "Valeurs": "Values",
  "Nom": "Name",
  "Nom de famille": "Last Name",
  "Notes": "Notes",
  "Type": "Type",
  "Supprimer": "Delete",
  "Ajouter": "Add",
  "Mauvais état à partir de ": "Bad condition from ",
  "Ajout docteur": "Add doctor",
  "E-mail": "Email",
  "Votre adresse e-mail": "Your email address",
  "Prénom": "First Name",
  "Numéro RPPS": "RPPS Number",
  "Type de compte": "Account type",
  "Créer": "Create",
  "Édition docteur": "Edit doctor",
  "Suppression docteur": "Delete doctor",
  "Attention cette action est irréversible et empêchera le docteur d'accéder à son compte et à tous les patients associés, ainsi qu'à votre clinique.": "Warning, this action is irreversible and will prevent the doctor from accessing their account and all associated patients, as well as your clinic.",
  "Êtes-vous certaine de vouloir supprimer le compte ?": "Are you sure you want to delete the account?",
  "Médecins de la clinique": "Clinic doctors",
  "Ajout patient": "Add patient",
  "Modification patient": "Edit patient",
  "Suppression patient": "Delete patient",
  "Attention cette action est irréversible et vous empêchera d'accéder à toutes les informations relative au patient.": "Warning, this action is irreversible and will prevent you from accessing all patient-related information.",
  "Êtes-vous certaine de vouloir supprimer le patient ?": "Are you sure you want to delete the patient?",
  "Patients de la clinique": "Clinic patients",
  "Ajouter un patient": "Add a patient",
  "Admininistrateur clinique": "Clinic administrator",
  "Docteur": "Doctor",
  "Non nécessaire": "Not necessary",
  "Bon": "Good",
  "Mauvais": "Poor",
  "Moyen": "Medium",
  "Sévère": "Severe",
  "Positive": "Positive",
  "Nulle": "Zero",
  "Négative": "Negative",
  "Masculin": "Male",
  "Féminin": "Female",
  "Taille": "Height",
  "Antécédent de chirurgie réfractive au laser": "History of refractive laser surgery",
  "Bump": "Bump",
  "Le patient souhaite être indépendant aux lunettes ?": "Does the patient want to be glasses-independent?",
  "Le patient accepte les effets photiques ?": "Does the patient accept photic effects?",
  "Heure de coucher": "Bedtime",
  "Temps de lecture par jour": "Reading time per day",
  "Temps de tablette par jour": "Tablet time per day",
  "Temps de smartphone par jour": "Smartphone time per day",
  "Temps d'autres activités de vision de près par jour": "Other near vision activities time per day",
  "Temps de discussion par jour": "Discussion time per day",
  "Temps de jeux de société par jour": "Board games time per day",
  "Temps d'utilisation de l'ordinateur par jour": "Computer usage time per day",
  "Temps de cuisine par jour": "Cooking time per day",
  "Temps de conduite par jour": "Driving time per day",
  "Temps de télévision par jour": "TV time per day",
  "Indépendance aux lunettes": "Glasses independence",
  "Distance minimum": "Minimum distance",
  "Distance maximum": "Maximum distance",
  "Activité préférentielle": "Preferential activity",
  "Interface patient": "Patient interface",
  "Hydrophile": "Hydrophilic",
  "Hydrophobe": "Hydrophobic",
  "MIOL": "MIOL",
  "EDOF": "EDOF",
  "Monofocal": "Monofocal",
  "Hybrid": "Hybrid",
  "CDVA": "CDVA",
  "NDVA": "NDVA",
  "High Order Aberration": "High Order Aberration",
  "Aberration sphérique": "Spherical Aberration",
  "Endothelium": "Endothelium",
  "Diamètre pupillaire": "Pupillary Diameter",
  "Aucune correction": "No correction",
  "Heure de réveil": "Wake-up time",
  "Temps de sieste": "Nap time",
  "Habitudes visuelles": "Visual habits",
  "Habitudes": "Habits",
  "Préconisation": "Recommendation",
  "Choix d'implants": "Implant choice",
  "Choix": "Choice",
  "P1": "IOL Match is an application intended for surgeons, helping you better target the needs of your patients before lens surgery. The goal is to assist you in choosing an intraocular lens that is best suited to the visual habits and ocular parameters of your patients. Please complete the biometrics information and the visual habits questionnaire, and let yourself be guided toward an optimized implant recommendation!",
  "P2": "IOL Match does not replace the analysis and expertise of the physician and cannot be held responsible for the final choice. IOL Match is only an additional tool to better understand visual habits and needs, aiming to support both the physician and the patient in making an informed intraocular lens decision.",
  "ans": "yrs",
  "Le patient a des antécédents de chirurgie laser réfractive avec un bon bump": "The patient has a history of refractive laser surgery with a good bump",
  "Le patient a des antécédents de chirurgie laser réfractive avec un mauvais bump": "The patient has a history of refractive laser surgery with a poor bump",
  "Le patient n'a pas d'antécédent de chirurgie laser réfractive": "The patient has no history of refractive laser surgery",
  "Le patient souhaite être indépendant des lunettes": "The patient wishes to be independent from glasses",
  "Le patient accepte de porter des lunettes": "The patient is willing to wear glasses",
  "Le patient accepte les effets photiques": "The patient accepts photic effects",
  "Le patient n'accepte pas les effets photiques": "The patient does not accept photic effects",
  "Âge": "Age",
  "Exporter": "Export",
  "Besoin de lunettes": "Need for glasses",
  "Choix final": "Final choice",
  "Type d'implant": "Implant type",
  "Nom de l'implant": "Implant name",
  "P3": "IOL Match does not replace the analysis and expertise of the physician and cannot be held responsible for the final choice. IOL Match is only an additional tool to better understand visual habits and needs, aiming to support both the physician and the patient in making an informed intraocular lens decision.",
  "Télécharger": "Download",
  "Courbes": "Curves",
  "Rétine/NO": "Retina/ON",
  "Génération du pdf...": "Generating pdf...",
  "Choisir un implant": "Choose an implant",
  "Modifier": "Modify",
  "Sélectionner un type": "Select a type",
  "Sélectionner": "Select",
  "Mot de passe": "Password",
  "Votre mot de passe": "Your password",
  "Inscription": "Registration",
  "Création de votre compte": "Create your account",
  "Finalisation de votre compte": "Finalise your account",
  "Mot de passe oublié": "Forgotten password",
  "Mot de passe oublié ?": "Forgot your password?",
  "Pas encore inscrit": "Not registred ?",
  "Récupérer mot de passe": "Get password",
  "S'affilier à une clinique": "Join a clinic",
  "Créer une clinique": "Create a clinic",
  "Continuer": "Continue",
  "Retour": "Back",
  "Nom de la clinique": "Name of the clinic",
  "Confirmation du mot de passe": "Password confirmation",
  "En cas d’aléa réfractif il sera peut nécessaire de porter une correction optique pour optimiser votre vision": "In case of refractive hazard it may be necessary to wear an optical correction to optimize your vision.",
  "Recherche": "Search",
  "Recherche par nom": "Search by name",
  "Bienvenue sur IOL Match": "Welcome on IOL Match !",
  "Taille en cm": "Size in cm",
  "État de l'oeil": "Eye state",
  "Ajouter un docteur": "Add doctor",
  "Édition d'un implant": "Implant edition",
  "Création d'un implant": "Implant creation",
  "Monoculaire ou Binoculaire": "Monocular or Binocular",
  "Taille échantillon de test (N)": "Test sample size (N)",
  "Méthodologie": "Methodology",
  "Note": "Note",
  "Aperçu": "Insight",
  "Attention": "Warning",
  "Si vous supprimer cet implant il n'apparaitra plus sur le profil des patients pour lesquels l'implant a été choisis.": "If you remove this implant it will no longer appear on the profile of the patients for whom the implant has been chosen.",
  "Cette action est irréversible, voulez-vous supprimer l'implant ?": "This action is irreversible, do you want to remove the implant?",
  "Ajouter un implant": "Add implant",
  "Si vous supprimer ce laboratoire vous supprimerez également tous les implants associés. Ceux-ci n'apparaitront plus sur le profil des patients pour lesquels les implants du laboratoire ont été choisis.": "If you delete this laboratory you will also delete all associated implants. These will no longer appear on the profile of patients for whom the laboratory implants have been chosen.",
  "Cette action est irréversible, voulez-vous supprimer le laboratoire ?": "This action is irreversible, do you want to remove the laboratory?",
  "Suppression d'un laboratoire": "Delete a laboratory",
  "Suppression d'un implant": "Delete an implant",
  "Création d'un laboratoire": "Create a laboratory",
  "Édition d'un laboratoire": "Edit a laboratory",
  "Ajouter un laboratoire": "Add a laboratory",
  "Réinitialiser": "Reset",
  "Biométrie enregistrée": "Biometrics saved",
  "en m": "in meters",
  "Une erreur est survenue": "An error has occurred",
  "Vous souhaitez rejoindre l'app IOL Match ?": "Would you like to join the IOL Match app?",
  "Créez votre compte": "Create your account",
  "Vous souhaitez terminer votre inscription et avez un code de vérification ?": "Would you like to complete your registration and have a verification code?",
  "Finalisez votre inscription": "Finalise your registration",
  "Déjà un code ?": "A code already?",
  "Code": "Code",
  "Votre code": "Your code",
  "Nouveau mot de passe": "New password",
  "Confirmer le mot de passe": "Confirm password",
  "Demander un code": "Request a code",
  "Envoyer": "Send",
  "Code de confirmation": "Confirmation code",
  "Votre code de confirmation reçu par e-mail": "Your confirmation code received by email",
  "Vous avez déjà un compte ?": "Already have an account?",
  "Connectez-vous": "Sign in",
  "S'inscrire": "Sign up",
  "Votre prénom": "Your first name",
  "Votre nom": "Your name",
  "Créer votre compte": "Create your account",
  "est requis": "is required",
  "Vous devez modifier votre mot de passe pour pouvoir vous connecter.": "You must modify your password to be able to sign in.",
  "Confirmer": "Confirm",
  "Date": "Date",
  "Actions": "Actions",
  "Êtes-vous sûr de vouloir supprimer ce patient ?": "Are you sure you want to remove this patient?",
  "Êtes-vous sûr de vouloir supprimer ce document ?": "Are you sure you want to remove this document?",
  "Êtes-vous sûr de vouloir supprimer ce laboratoire ?": "Are you sure you want to remove this laboratory?",
  "Aucun patient n'a été trouvé": "No patient found",
  "Données": "Data",
  "Date de naissance": "Birth date",
  "Nom du patient": "Patient name",
  "Pr.Xr du patient": "Patient first name",
  "Date denaissance du patient": "Patient birth date",
  "Nom du docteur": "Doctor name",
  "Mettre à jour un patient": "Update a patient",
  "Mettre à jour un laboratoire": "Update a laboratory",
  "Télécharger le fichier source": "Download source file",
  "Rendre disponible hors connexion": "Make available offline",
  "Renommer": "Rename",
  "Mettre à jour": "Update",
  "Historique": "History",
  "IOL Match est une application destinée aux chirurgiens, et vous aide à mieux cibler les besoins de vos patients avant une chirurgie du cristallin. L’objectif étant de vous accompagner lors du choix d’implant intraoculaire, afin qu’il soit le plus adapté aux habitudes visuelles ainsi qu’aux paramètres oculaires de vos patients. Merci de bien vouloir compléter les informations de biométrie ainsi que le questionnaire d’habitudes visuelles, et laissez-vous guider !": "IOL Match is an application designed for surgeons, and helps you to better target the needs of your patients prior to lens surgery. The aim is to help you choose an intraocular implant that is best suited to your patients' visual habits and to your patients' visual habits and ocular parameters. Please complete the biometric information and the visual habits questionnaire visual habits questionnaire, and let us guide you!",
  "IOL Match ne remplace pas l’analyse et l’expertise du médecin, et ne peut en aucun cas être tenu responsable du choix final. IOL Match n’est qu’un outil supplémentaire permettant de retranscrire les habitudes et besoins visuels afin de mieux accompagner le médecin et le patient lors de la décision d’implant intraoculaire.": "IOL Match does not replace the analysis and expertise of the doctor, and can in no way be held responsible for the final choice. IOL Match is simply a supplementary tool that enables visual habits and needs to be transcribed in order to better support the doctor and the patient when deciding on an intraocular implant.",
  "Monovision": "Monovision",
  "Oeil dominant": "Dominant eye",
  "Droit": "Right",
  "Gauche": "Left",
  "Les deux yeux ont les mêmes caractéristiques": "Both eyes have the same characteristics",
  "Cornée - Aberration d'ordre élevé": "Cornea - High order aberration",
  "Cornée - Aberration sphérique": "Cornea - Spherical aberration",
  "Cornée - Endothelium": "Cornea - Endothelium",
  "Yeux": "Eyes",
  "Oeil gauche": "Left eye",
  "Oeil droit": "Right eye",
  "Oeil droit et oeil gauche": "Right and left eye",
  "Ajouter une activité": "Add an activity",
  "Favoris": "Favorites",
  "Les deux yeux auront le même implant": "Both eyes will have the same implant",
  "Matériau": "Material",
  "Chercher un laboratoire": "Search a laboratory",
  "Chercher un implant": "Search an implant",
  "Décalage": "Offset",
  "Choix 1": "Choice 1",
  "Choix 2": "Choice 2",
  "Informer le patient que des lunettes seront sûrement nécessaires après l’intervention pour la": "Inform the patient that glasses will probably be necessary after the operation for the",
  "Vous devez choisir au moins un implant": "You must choose at least one implant",
  "Choix enregistrés": "Choices saved",
  "Combinaison": "Combination",
  "Patient": "Patient",
  "Aucun laboratoire n'a été trouvé": "No laboratory found",
  "Vous devez renseigner votre nouveau mot de passe": "You must enter your new password",
  "Votre mot de passe doit contenir au minimum 8 charactères dont un chiffre, une minuscule, une majuscule et un caractère special de la liste suivante :": "Your password must contain at least 8 characters, including a number, a lowercase, an uppercase and a special character from the list below:",
  "Vous devez confirmer votre nouveau mot de passe pour changer de mot de passe": "You must confirm your new password to change your password",
  "La confirmation ne correspond pas au mot de passe": "The confirmation does not match the password",
  "Supprimer la dernière activité": "Delete the smallest activity",
  "Modifier un implant": "Update implant",
  "Informations générales (FR)": "General information (FR)",
  "Informations générales (EN)": "General information (EN)",
  "Modifier les paramètres": "Update settings",
  "Binoculaire": "Binocular",
  "NOM": "NAME",
  "Bienvenue sur IOL Match !": "Welcome to IOL Match!",
  "Télécharger le rapport": "Download report",
  "OD": "OD",
  "OG": "OS",
  "ODG": "OU",
  "Après la chirurgie, une correction visuelle complémentaire pourra être nécessaire pour certaines activités.": "After surgery, additional visual correction may be required for certain activities.",
  "Oeil à opérer": "Eye to operate",
  "Les deux yeux ont les mêmes caractéristiques biométriques": "Both eyes have the same biometric characteristics",
  "Je souhaite tout de même renseigner l’état de l’oeil controlatéral": "I still wish to indicate the condition of the contralateral eye",
  "Antécédents de chirurgie réfractive cornéenne": "History of corneal refractive surgery",
  "Antécédents de chirurgie du cristallin": "History of lens surgery",
  "Type d’implant actuel": "Current implant type",
  "Je souhaite mettre un AddOn": "I wish to place an AddOn",
  "Courbe \"": "Default \"",
  "\" par défaut": "\" curve",
  "Courbe du patient": "Patient's curve",
  "Je souhaite comparer des implants": "I wish to compare implants",
  "Sélectionner un laboratoire": "Select a laboratory",
  "Ajouté au favoris": "Added to favorites",
  "Ajouter au favoris": "Add to favorites",
  "Décalage de la courbe de l’œil à opérer": "Offset of the curve of the eye to be operated on",
  "Options avancées": "Advanced options",
  "Afficher la courbe de l’oeil déjà opéré": "Display the curve of the already operated eye",
  "Amétropie de l'oeil déjà opéré (SE)": "Refractive error of the already operated eye (SE)",
  "Oeil dominé": "Dominated eye",
  "Courbe oeil opéré OD": "Operated eye curve OD",
  "Courbe oeil opéré OG": "Operated eye curve OS",
  "dominé": "dominated",
  "Sans préférence": "Without preference",
  "Cet oeil n'est pas à opérer": "This eye is not to be operated on.",
  "Choisir cet implant": "Choose this implant",
  "Courbe de l'implant": "Implant curve",
  "entre 2mm et 2.5mm": "between 2mm and 2.5mm",
  "Aide contextuelle": "Contextual help",
  "Gérez les textes d'aide qui s'affichent dans les formulaires": "Manage help texts displayed in forms",
  "Afficher uniquement mes personnalisations": "Show only my customizations",
  "Personnalisé": "Customized",
  "Par défaut": "Default",
  "Champ": "Field",
  "Aucun texte d'aide trouvé": "No help text found",
  "Chargement...": "Loading...",
  "Effets photiques": "Photic effects",
  "Indépendance des lunettes": "Glasses independence",
  "État œil controlatéral": "Contralateral eye state",
  "Courbe de défocus": "Defocus curve",
  "Aberrométrie": "Aberrometry",
  "Activités préférentielles": "Preferential activities",
  "Comparaison d'implants": "Implant comparison",
  "Matériau de l'implant": "Implant material",
  "Décalage de courbe": "Curve offset",
  "Pupillométrie": "Pupillometry",
  "Topographie": "Topography",
  "Temps d'éveil": "Wake time",
  "Vision de près": "Near vision",
  "Vision intermédiaire": "Intermediate vision",
  "Vision de loin": "Distance vision",
  "Personnaliser le texte d'aide": "Customize help text",
  "Modifier le texte d'aide": "Edit help text",
  "Modifier le texte par défaut": "Edit default text",
  "Mode administrateur": "Administrator mode",
  "Nom du champ": "Field name",
  "Texte en français": "French text",
  "Texte en anglais (optionnel)": "English text (optional)",
  "Ce texte sera affiché aux utilisateurs francophones": "This text will be displayed to French-speaking users",
  "Ce texte sera affiché aux utilisateurs anglophones": "This text will be displayed to English-speaking users",
  "Voir": "View",
  "Envoyer le lien": "Send link",
  "sélectionné(s)": "selected",
  "Annuler la sélection": "Cancel selection",
  "Ajouter un patient": "Add a patient",
  "Mode sélection": "Selection mode",
  "Choisir le texte à modifier": "Choose text to edit",
  "En tant qu'administrateur, vous pouvez modifier le texte par défaut pour tous les utilisateurs ou créer votre propre personnalisation.": "As an administrator, you can edit the default text for all users or create your own customization.",
  "Modifier ma personnalisation": "Edit my customization",
  "Créer ma personnalisation": "Create my customization",
  "Modifier le texte par défaut (tous les utilisateurs)": "Edit default text (all users)",
  "Confirmation": "Confirmation",
  "Voulez-vous vraiment supprimer cette personnalisation ?": "Do you really want to delete this customization?",
  "Voulez-vous vraiment supprimer votre personnalisation et revenir au texte par défaut ?": "Do you really want to delete your customization and revert to the default text?",
  "Texte d'aide enregistré": "Help text saved",
  "Personnalisation supprimée": "Customization deleted",
  "Erreur lors de l'enregistrement": "Error while saving",
  "Erreur lors de la suppression": "Error while deleting",
  "Erreur: données manquantes": "Error: missing data",
  "Tous": "All",
  "Filtrer par statut": "Filter by status",
  "En cours": "In progress",
  "Finalisé": "Completed",
  "Finalisés": "Completed",
  "Archivé": "Archived",
  "Archivés": "Archived",
  "Archiver": "Archive",
  "Désarchiver": "Unarchive",
  "Patient archivé": "Patient archived",
  "Patient désarchivé": "Patient unarchived",
  "Sélectionner": "Select",
  "Supprimer ({{count}})": "Delete ({{count}})",
  "Êtes-vous sûr de vouloir supprimer {{count}} patient(s) ?": "Are you sure you want to delete {{count}} patient(s)?",
  "Succès": "Success",
  "Réinitialiser": "Reset",
  "Désinscription": "Unregister",
  "Tout sélectionner": "Select all",
  "Tout désélectionner": "Deselect all",
  "Tous": "All",
  "Aucun": "None",
  "patient": {
    "greeting": "Hello",
    "welcomeTitle": "Form access",
    "accessGranted": "Access granted",
    "email": "Email",
    "telephone": "Phone",
    "nextSteps": "Next steps",
    "stepBiometrie": "Biometric data",
    "stepBiometrieDesc": "Information about your vision",
    "stepHabitudes": "Visual habits",
    "stepHabitudesDesc": "Your daily activities",
    "stepValidation": "Validation",
    "stepValidationDesc": "Confirmation of your data",
    "startForm": "Start questionnaire",
    "step": "Step",
    "of": "of",
    "completed": "completed",
    "loading": "Loading...",
    "completeForm": "Complete the form",
    "completeFormDesc": "Fill in your biometric information and visual habits",
    "schedule": "Schedule",
    "saving": "Saving...",
    "savedAt": "Saved",
    "justNow": "Just now",
    "minuteAgo": "1 minute ago",
    "minutesAgo": "{{count}} minutes ago",
    "hourAgo": "1 hour ago",
    "hoursAgo": "{{count}} hours ago",
    "dataSection": "Data",
    "lastName": "Last name",
    "firstName": "First name",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "height": "Height in cm",
    "birthdate": "Date of birth",
    "acceptPhoticEffects": "Do you accept photic effects?",
    "wantGlassesIndependence": "Do you want to be independent from glasses?",
    "yes": "Yes",
    "no": "No",
    "validate": "Validate",
    "previous": "Previous",
    "next": "Next",
    "selectGenderError": "Please select your gender",
    "enterBirthdateError": "Please enter your date of birth",
    "enterHeightError": "Please enter a valid height (between 100 and 250 cm)",
    "saveError": "Error while saving",
    "wakeupTime": "Wake time",
    "wakeupHour": "Wake-up time",
    "bedtimeHour": "Bedtime",
    "napTime": "Nap time",
    "nearVision": "Near vision",
    "readingTime": "Reading time per day",
    "tabletTime": "Tablet time per day",
    "smartphoneTime": "Smartphone time per day",
    "otherNearVisionTime": "Other near vision activities per day",
    "intermediateVision": "Intermediate vision",
    "discussionTime": "Discussion time per day",
    "boardGamesTime": "Board games time per day",
    "computerTime": "Computer time per day",
    "cookingTime": "Cooking time per day",
    "distanceVision": "Distance vision",
    "drivingTime": "Driving time per day",
    "tvTime": "TV time per day",
    "preferredActivities": "Preferred activities",
    "activity": "Activity",
    "whyKeepDepthOfField": "Why do you want to keep this depth of field?",
    "minDistance": "Minimum distance (m)",
    "maxDistance": "Maximum distance (m)",
    "addActivity": "Add activity",
    "removeLastActivity": "Remove last activity",
    "confirmationTitle": "Confirmation of your data",
    "confirmationDesc": "Please check the information entered before submitting the form",
    "submit": "Submit",
    "submitting": "Submitting...",
    "thankYou": "Thank you!",
    "formSubmitted": "Your form has been successfully submitted",
    "dataRecap": "Summary of your data",
    "tokenMissing": "Token missing in URL. Please use the complete link provided by your surgeon.",
    "technicalError": "Technical error. Please try again.",
    "connectionError": "Connection error. Please check your internet connection and try again.",
    "linkInvalid": "This link is not valid. Please check that you are using the complete link sent by your surgeon.",
    "linkExpired": "This link has expired. Please contact your surgeon to get a new link.",
    "linkUsed": "This link has already been used. If you need to modify your information, please contact your surgeon.",
    "validating": "Validating...",
    "verifyingLink": "Verifying your access link",
    "retry": "Retry",
    "validationFailed": "Validation failed",
    "correctErrors": "Please correct the errors before continuing",
    "tokenNotFound": "Token not found",
    "error": "Error",
    "biometricData": "Biometric data",
    "visualHabits": "Visual habits",
    "importantInfo": "Important information",
    "modify": "Modify",
    "finalize": "Finalize and send",
    "formSentSuccess": "Form sent successfully",
    "thankYouMessage": "Thank you for completing the form. Your surgeon has received your information.",
    "close": "Close",
    "recap": "Summary",
    "reviewBeforeSubmit": "Please review your information before submitting the form",
    "sex": "Gender",
    "size": "Height",
    "acceptsPhoticEffects": "Accepts photic effects",
    "wantsGlassesIndependence": "Wants glasses independence",
    "wakeTime": "Wake time",
    "napDuration": "Nap duration",
    "readingDuration": "Reading duration",
    "tabletDuration": "Tablet duration",
    "smartphoneDuration": "Smartphone duration",
    "otherNearActivities": "Other near activities",
    "discussionDuration": "Discussion duration",
    "boardGamesDuration": "Board games duration",
    "computerDuration": "Computer duration",
    "cookingDuration": "Cooking duration",
    "drivingDuration": "Driving duration",
    "tvDuration": "TV duration",
    "activities": "Activities",
    "distance": "Distance",
    "name": "Name",
    "description": "Description",
    "confidentiality": "Confidentiality",
    "confidentialityDesc": "Your data is secure and will only be used for your medical care.",
    "modifications": "Modifications",
    "modificationsDesc": "After submission, contact your surgeon for any modifications.",
    "followUp": "Follow-up",
    "followUpDesc": "Your surgeon will contact you for the next steps of your care.",
    "sending": "Sending...",
    "dataAnalysis": "Data analysis",
    "dataAnalysisDesc": "Your surgeon will analyze your information",
    "implantChoice": "Implant choice",
    "implantChoiceDesc": "Selection of the most suitable implant",
    "contactYou": "Contact",
    "contactYouDesc": "You will be contacted for planning",
    "thankYouFull": "Thank you {{name}}! Your data has been transmitted to your surgeon. You will be contacted soon for the next steps of your care.",
    "canCloseWindow": "The questionnaire is complete and the medical team has received your responses. You can close this page.",
    "requestNewLink": "Request a new link",
    "requestNewLinkSent": "Request sent to your surgeon",
    "requestNewLinkError": "Error sending request. Please try again."
  },
  "sendLink": {
    "title": "Send patient questionnaire",
    "patientLabel": "Patient",
    "loadingPatient": "Loading patient data...",
    "patientNotFound": "Patient not found",
    "back": "Back",
    "configuration": "Configuration",
    "patientEmail": "Patient email",
    "linkValidity": "Validity period",
    "validity24h": "24h",
    "validity48h": "48h",
    "validity72h": "72h",
    "customMessage": "Accompanying message",
    "customMessageHelp": "The text [LIEN_QUESTIONNAIRE] will be automatically replaced by the generated link",
    "customMessagePlaceholder": "Message to send with the questionnaire link",
    "generateLink": "Generate patient link",
    "linkGeneratedTitle": "Link generated successfully",
    "linkGeneratedDesc": "The following link has been generated:",
    "validityLabel": "Validity: {{hours}} hours",
    "copy": "Copy",
    "share": "Share",
    "send": "Send",
    "emailRequired": "Valid email required",
    "linkGeneratedSuccess": "Link generated successfully",
    "linkGenerationError": "Error generating link",
    "emailSentSuccess": "Email sent successfully",
    "emailSendError": "Error sending email",
    "linkCopied": "Link copied to clipboard",
    "defaultMessage": "Your surgeon invites you to complete a preoperative questionnaire to prepare for your cataract surgery.\n\nThis questionnaire will help personalize the choice of your intraocular implant according to your visual needs and lifestyle.\n\nClick on the link below to access the questionnaire:\n[LIEN_QUESTIONNAIRE]\n\nThank you for taking a few minutes to complete this form."
  }
}
